export { default } from "./ForgotPasswordRequest.js";
